export class SitePageScoresTableRowModel {
    pageId: number;
    path: string;
    gpd: number;
    gpm: number;
    seoIndex: number;
    seoFollow: number;
    seoTitle: number;
    seoDescription: number;
}



// WEBPACK FOOTER //
// C:/Visual Studio Projects/Novicell Performance Platform/PerformancePlatform/Novicell.Performance.Website/ui/src/app/models/SitePageScoresTableRowModel.ts